import { User } from '@order-management/types';
import { AxiosError } from 'axios';
import { ReactNode, createContext } from 'react';

export type UsersContextProps = {
  user: User;
  loading: boolean;
  isRefetching: boolean;
  error?: AxiosError;
  refetchUser: () => Promise<void>;
};

export const UsersContext = createContext<UsersContextProps>({
  user: {} as User,
  loading: true,
  isRefetching: false,
  error: {} as AxiosError,
  refetchUser: async () => {},
});

export type UsersProviderProps = {
  user: User;
  loading: boolean;
  isRefetching: boolean;
  error?: AxiosError;
  refetchUser: () => Promise<void>;
  children: ReactNode;
};

export const UsersProvider = ({
  user,
  loading,
  isRefetching,
  error,
  refetchUser,
  children,
}: UsersProviderProps) => {
  return (
    <UsersContext.Provider
      value={{ user, loading, isRefetching, error, refetchUser }}
    >
      {children}
    </UsersContext.Provider>
  );
};
